import dayjs from "dayjs";

const getRentalDate = (value) => {
  if (!value) return "--";
  const [day, month, year] = value.split("-");
  return dayjs(new Date(year, month - 1, day)).format("DD MMM YYYY");
};

export default getRentalDate;
